import { render } from "./main-indicator-count.vue?vue&type=template&id=cd3a9636&scoped=true"
import script from "./main-indicator-count.vue?vue&type=script&lang=js"
export * from "./main-indicator-count.vue?vue&type=script&lang=js"

import "./main-indicator-count.vue?vue&type=style&index=0&id=cd3a9636&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd3a9636"]])

export default __exports__